import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from '../../default-cloud-graph-conversation-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from '../../default-cloud-graph-design-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from '../../default-cloud-graph-space-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgeK15tScrollSitesIcon } from './icon';
import { ForgeK15tScrollSitesSearchResultIcon } from './search-result-icon';

export const forgeK15tScrollSitesConfig: ThirdPartyConfig = {
	displayName: 'Scroll Sites by k15t',
	id: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
	resourceType: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
	icon: get3PLogo(ForgeK15tScrollSitesIcon, 'ForgeK15tScrollSites', 'medium'),
	searchResultIcon: get3PLogo(
		ForgeK15tScrollSitesSearchResultIcon,
		'ForgeK15tScrollSites',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				],
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Space,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Conversation,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
